const accessLevels = {
	OWNER: 'owner',
	LOCATION_ADMIN: 'location-admin',
	TEAM_LEADER: 'team-leader',
	TEAM_MEMBER: 'team-member',
	CONTRIBUTOR: 'contributor',
	TEAM_MEMBER_LIMITED: 'team-member-limited'
};

export default accessLevels;
